import { merge } from 'lodash';
import { useEffect, useState } from 'react';
import { AnyStateMachine } from 'xstate';
import { SecondaryIdFieldMetadata } from '~/components/inputs/secondary-identifier/secondary-identifier.component';
import { EnrollmentMachine } from '~/machines/enrollment-selection';
import { ContextSendMatch } from '~/machines/utils/types';
import { LDClient, LDFlags } from '~/providers';
import { DeepPartial } from '~/typings/utils';
import { store } from '~/utils/store';
import { AccountNumber, AccountNumberProps } from './account-number.component';

type AccountNumberContainerProps = {
  micro: ContextSendMatch<EnrollmentMachine>;
  funnel: ContextSendMatch<AnyStateMachine>;
  overrideCopy?: AccountNumberProps['overrideCopy'];
  overrideProps?: DeepPartial<AccountNumberProps>;
};

export const AccountNumberContainer = ({
  micro: { context, matches, send },
  overrideCopy,
  overrideProps,
}: AccountNumberContainerProps) => {
  const [secondaryIdFieldMetadata, setSecondaryIdFieldMetadata] = useState<
    SecondaryIdFieldMetadata[]
  >(LDClient.variation(LDFlags.showSecondaryAccountIdentifier));
  useEffect(() => {
    LDClient.on('change', () => {
      setSecondaryIdFieldMetadata(LDClient.variation(LDFlags.showSecondaryAccountIdentifier));
    });
  }, []);

  useEffect(() => {
    if (secondaryIdFieldMetadata?.length)
      store.set('SECONDARY_ID_FIELD_METADATA', secondaryIdFieldMetadata);
  }, [secondaryIdFieldMetadata]);

  const props: AccountNumberProps = {
    context: {
      user: context.funnelPacket.user,
      utility: context.funnelPacket.utility,
      hideDualBillExplainer: context.hideDualBillExplainer,
      utilityAccountNumber:
        context.utilityAccountNumber || context.funnelPacket.utilityAccount.accountNumber!,
      enrollmentOptions: context.enrollmentOptions,
      secondaryIdentifier: context.funnelPacket.utilityAccount.secondaryAccountIdentifier!,
      funnelPacket: context.funnelPacket,
      funnelId: context.funnelId,
    },
    secondaryIdFieldMetadata: store.get('SECONDARY_ID_FIELD_METADATA') || secondaryIdFieldMetadata,
    error: context.errors.accountNumber,
    next: data => send({ type: 'SUBMIT_UTILITY_ACCOUNT_NUMBER', data }),
    overrideCopy,
    pending: matches('accountNumber.submitting'),
  };

  return <AccountNumber {...merge(props, overrideProps)} />;
};
